import React, { Component } from 'react';
import InputField from '../../components/inputs/inputField';
import API from '../../utils/API';

class PlannerInfo extends Component {
	constructor(props) {
		super(props);
		const { venue } = props;
		
		this.state = {
			editedVenue: {
				plannerInfo: venue.plannerInfo || {
					firstName: '',
					lastName: '',
					phone: '',
					title: '',
					email: '',
					address: {
						country: 'US',
						state: '',
						city: '',
						zipCode: ''
					}
				}
			},
			editing: false,
			saving: false,
			requiredFields: {
				firstName: false,
				lastName: false,
				email: false
			}
		};
	}

	updatePlannerInfo = (field, value) => {
		const { editedVenue } = this.state;
		editedVenue.plannerInfo[field] = value;
		this.setState({ editedVenue, editing: true });
	};

	updateAddress = (field, value) => {
		const { editedVenue } = this.state;
		editedVenue.plannerInfo.address[field] = value;
		this.setState({ editedVenue, editing: true });
	};

	saveDetails = async () => {
		const { editedVenue, requiredFields } = this.state;
		const { plannerInfo } = editedVenue;
		
		let valid = true;
		
		if (!plannerInfo.firstName) {
			requiredFields.firstName = true;
			valid = false;
		} else {
			requiredFields.firstName = false;
		}
		
		if (!plannerInfo.lastName) {
			requiredFields.lastName = true;
			valid = false;
		} else {
			requiredFields.lastName = false;
		}
		
		if (!plannerInfo.email) {
			requiredFields.email = true;
			valid = false;
		} else {
			requiredFields.email = false;
		}
		
		if (!valid) {
			this.setState({ requiredFields });
			return;
		}
		
		this.setState({ saving: true });
		
		try {
			await API().patch(
				`Organizations/${this.props.orgId}/sourced-venues/${this.props.venueId}`,
				{ plannerInfo: plannerInfo }
			);
			
			this.setState({ editing: false, saving: false });
			this.props.refreshSectionCounts && this.props.refreshSectionCounts();
		} catch (error) {
			console.error('Error saving planner info:', error);
			this.setState({ saving: false });
		}
	};

	cancelEdit = () => {
		const { venue } = this.props;
		this.setState({
			editedVenue: {
				plannerInfo: venue.plannerInfo || {
					firstName: '',
					lastName: '',
					phone: '',
					title: '',
					email: '',
					address: {
						country: 'US',
						state: '',
						city: '',
						zipCode: ''
					}
				}
			},
			editing: false,
			requiredFields: {
				firstName: false,
				lastName: false,
				email: false
			}
		});
	};

	render() {
		const { editedVenue, editing, requiredFields } = this.state;
		const { venue } = this.props;
		const { plannerInfo } = editedVenue;
		
		return (
			<div className="sectionContainer">
				
				<div className="sectionBody">
					<div className="sectionBlock">
						<h2 className="blockHeader">Planner Contact Details</h2>
						
						<div className="flex wrap" style={{ gap: '15px' }}>
							<div style={{ flex: '1 1 250px' }}>
								<InputField
									label="First Name"
									required={true}
									errorTrigger={requiredFields.firstName}
									value={plannerInfo.firstName}
									onChange={(e) => this.updatePlannerInfo('firstName', e.target.value)}
									placeholder="Planner's first name"
								/>
							</div>
							<div style={{ flex: '1 1 250px' }}>
								<InputField
									label="Last Name"
									required={true}
									errorTrigger={requiredFields.lastName}
									value={plannerInfo.lastName}
									onChange={(e) => this.updatePlannerInfo('lastName', e.target.value)}
									placeholder="Planner's last name"
								/>
							</div>
						</div>
						
						<InputField
							label="Title"
							value={plannerInfo.title}
							onChange={(e) => this.updatePlannerInfo('title', e.target.value)}
							placeholder="e.g., Event Manager, Director of Events"
						/>
						
						<div className="flex wrap" style={{ gap: '15px' }}>
							<div style={{ flex: '1 1 250px' }}>
								<InputField
									label="Email"
									required={true}
									errorTrigger={requiredFields.email}
									type="email"
									value={plannerInfo.email}
									onChange={(e) => this.updatePlannerInfo('email', e.target.value)}
									placeholder="planner@company.com"
								/>
							</div>
							<div style={{ flex: '1 1 250px' }}>
								<InputField
									label="Phone Number"
									type="tel"
									value={plannerInfo.phone}
									onChange={(e) => this.updatePlannerInfo('phone', e.target.value)}
									placeholder="(555) 123-4567"
								/>
							</div>
						</div>
					</div>
					
					<div className="sectionBlock">
						<h2 className="blockHeader">Planner Address</h2>
						
						<InputField
							label="Country"
							value={plannerInfo.address.country}
							onChange={(e) => this.updateAddress('country', e.target.value)}
						/>
						
						<div className="flex wrap" style={{ gap: '15px' }}>
							<div style={{ flex: '1 1 250px' }}>
								<InputField
									label="State/Province"
									value={plannerInfo.address.state}
									onChange={(e) => this.updateAddress('state', e.target.value)}
									placeholder="CA"
								/>
							</div>
							<div style={{ flex: '1 1 250px' }}>
								<InputField
									label="City"
									value={plannerInfo.address.city}
									onChange={(e) => this.updateAddress('city', e.target.value)}
									placeholder="San Francisco"
								/>
							</div>
						</div>
						
						<InputField
							label="Zip Code"
							value={plannerInfo.address.zipCode}
							onChange={(e) => this.updateAddress('zipCode', e.target.value)}
							placeholder="94102"
						/>
					</div>
				</div>
				
			</div>
		);
	}
}

export default PlannerInfo;
